export const LOYALTY_LANDING_PAGE = 'societe'
export const LOYALTY_TERMS_AND_CONDITIONS_PAGE = 'societe-terms-and-conditions'
export const TASTE_OF_GOLD_DETAILS_PAGE = 'societe/taste-of-gold/details'
export const TIER_UPGRADE_CAMPAIGN_PAGE = 'societe/:campaignSlug'
